import { Paths } from '../../lib/constants/path'
import { RoleEnum } from '../../lib/types/enums/users/role.enum'
import { Route } from '../../lib/types/routes'
import TransferCreatePage from './transfer-create-page'
import TransferListPage from './transfer-list-page'
import TransferUpdatePage from './transfer-update-page'

const transferRoutes: Route[] = [
  {
    path: Paths.TRANSFER_LIST_PAGE,
    element: <TransferListPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.TRANSFER_CREATE_PAGE,
    element: <TransferCreatePage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.TRANSFER_UPDATE_PAGE,
    element: <TransferUpdatePage />,
    roles: [RoleEnum.ADMIN]
  }
]

export default transferRoutes
